import type { ReactNode } from 'react'
import './enroll.css'

interface StickyActionBarProps {
  children: ReactNode
}

/**
 * Sticky bottom bar for enrollment-wizard primary CTAs (`EnrollPage`,
 * `MyEnrollPage`). Uses `sticky` (not `fixed`) so it only pins to the bottom
 * of its scrolling ancestor once that ancestor's content overflows — it
 * never permanently overlays content the way a `fixed` bar would. Inside
 * Layout the mobile tab bar is a sibling BELOW <main> (the scroll container),
 * so the bar pins above it without overlapping. The opaque `bg-kumo-base`
 * background prevents scrolled-under content from showing through, and
 * `border-t` gives a subtle separator from the content above.
 *
 * Render this INSIDE a `<form>` when the CTA is a `type="submit"` button —
 * that preserves native form-submit association without needing the
 * button's `form` attribute. Put `enroll-cta w-full` on the Button.
 */
export function StickyActionBar({ children }: StickyActionBarProps) {
  return (
    <div
      data-testid="enroll-sticky-actions"
      className="enroll-sticky sticky bottom-0 z-10 border-t border-kumo-line bg-kumo-base py-3"
    >
      {children}
    </div>
  )
}
